import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getPlaylistTypeLabel = playlistType => playlistType === 'LEARNING_PATH' ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.myTeam.playlists.hubspotPlaylist"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.myTeam.playlists.playlist"
});
export const getProgressPercent = ({
  completedItems,
  totalPlaylistItems
}) => Math.round(completedItems / Math.max(1, totalPlaylistItems) * 100);
export const isTab = value => value === 'all' || value === 'completed' || value === 'incomplete';
export const getStatus = tab => isTab(tab) ? tab === 'all' ? undefined : tab.toUpperCase() : undefined;